import React from 'react';
import PropTypes from 'prop-types';
import { useDraggable } from '@dnd-kit/core';
import './SignageEditor.css';

const Draggable = ({ id, children, onDragStart, onDragEnd }) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    onDragStart,
    onDragEnd,
  });

  return (
    <div ref={setNodeRef} {...listeners} {...attributes} className="asset">
      {children}
    </div>
  );
};

Draggable.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
};

export default Draggable;
